import { jsx as _jsx } from "react/jsx-runtime";
import { withGenericConfig } from "/contexts/generic-config-context";
import LiveBoardTabComponent from "../live-board-tab-component";
import { inviteGridItems } from "./invite-tab-consts";
const InviteTabContentComponent = (props)=>{
    const { translate, onCardClick } = props;
    return /*#__PURE__*/ _jsx("div", {
        className: "invite-tab-content",
        children: /*#__PURE__*/ _jsx(LiveBoardTabComponent, {
            description: translate("liveBoard.inviteTab.description"),
            gridItems: inviteGridItems,
            hideCardParagraph: true,
            onCardClick: onCardClick
        })
    });
};
export default withGenericConfig(InviteTabContentComponent);
